import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useAuth from "hooks/useAuth";
import { DASHBOARD_PATH } from "config";

const RoleGuard = ({ allowedRoles, children }) => {
  const { user, isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();
  const roleKey = allowedRoles.join(",");
  const isAllowed = !allowedRoles.length || allowedRoles.includes(user?.role);

  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    if (!isLoggedIn) {
      navigate("/login", { replace: true });
      return;
    }

    if (!isAllowed) {
      navigate(DASHBOARD_PATH, { replace: true });
    }
  }, [isAllowed, isInitialized, isLoggedIn, navigate, roleKey]);

  if (!isInitialized) {
    return null;
  }

  if (!isAllowed) {
    return null;
  }

  return children;
};

RoleGuard.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

RoleGuard.defaultProps = {
  allowedRoles: [],
};

export default RoleGuard;
